<template>
    <div class="widget-filter-pop-up">
        <div class="widget-filter-pop-up-header">
            <h3>Filter</h3>
        </div>
        <div class="widget-filter-pop-up-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "widgetFilterPopUp",
    props: {

    },
    data() {
        return {};
    },
    watch: {},
    mounted() { },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
.widget-filter-pop-up {
    width: 500px;
    height: max-content;
    max-height: 700px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

    .widget-filter-pop-up-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        padding: 10px 20px;

        h3 {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .widget-filter-pop-up-body {
        height: max-content;
        max-height: 650px;
        padding: 0px 20px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
        padding-bottom: 19px;
    }
}
</style>